export function reloadDocument() {
  window.location.reload();
}
